import React from "react";
import { useNavigate } from "react-router-dom";
import './responseMessage.css';

const Failure = () => {
  const navigate = useNavigate();

  return (
    <div className="response-container failure">
      <h2>¡El pago fue rechazado! ❌</h2>
      <p>Hubo un problema con tu pago. Intenta nuevamente o usa otro medio.</p>
      <button className="response-btn" onClick={() => navigate('/')}>Volver al inicio</button>
    </div>
  );
};

export default Failure;
